import React from "react";
import { CustomIconComponentProps } from "@ant-design/icons/es/components/Icon";
import Icon from "@ant-design/icons";

function ConsumableIcon(props: Partial<CustomIconComponentProps>) {
  return (
    <Icon
      {...props}
      component={() => (
        <svg
          width={props.width || 24}
          height={props.height || 24}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="11.9753"
            cy="12.0635"
            r="9.53809"
            fill="#F0F0F0"
          />
          <path
            d="M3.26508 11.802C3.29047 10.6924 3.51898 9.61582 3.94809 8.60273C4.38734 7.56172 5.01703 6.62988 5.81938 5.825C6.62172 5.02012 7.55609 4.39043 8.59711 3.95117C9.67367 3.49668 10.8162 3.26562 11.9969 3.26562C13.1776 3.26562 14.3202 3.49668 15.3942 3.95117C16.4322 4.38953 17.3748 5.026 18.1694 5.825C18.4207 6.07637 18.6569 6.34297 18.8752 6.62227L17.578 7.40625C17.5478 7.42965 17.5247 7.4611 17.5116 7.497C17.4984 7.5329 17.4957 7.57179 17.5036 7.60919C17.5116 7.64658 17.5299 7.68098 17.5566 7.70841C17.5832 7.73584 17.617 7.7552 17.6542 7.76426L20.8485 8.78683C20.9755 8.8173 21.0999 8.72082 21.0999 8.59132L21.8402 4.94351C21.8402 4.77339 21.6447 4.6769 21.5126 4.78355L20.3961 5.43652C18.4436 2.93809 15.4069 1.33594 11.9944 1.33594C6.17738 1.33594 1.44457 5.99766 1.33539 11.7918C1.33471 11.8189 1.33947 11.8459 1.34937 11.8711C1.35927 11.8963 1.37413 11.9193 1.39306 11.9387C1.41199 11.9581 1.43461 11.9735 1.45959 11.9841C1.48457 11.9946 1.51141 12 1.53852 12L2.91654 11.9955C3.02825 11.9955 3.26254 11.9111 3.26508 11.802ZM22.4604 12H20.937C20.8252 12 20.7364 12.0889 20.7338 12.198C20.7084 13.3076 20.4799 14.3842 20.0508 15.3973C19.6116 16.4383 18.9819 17.3727 18.1795 18.175C17.3697 18.9882 16.4069 19.633 15.3466 20.0723C14.2864 20.5115 13.1496 20.7366 12.002 20.7344C10.8547 20.7365 9.71839 20.5115 8.65855 20.0722C7.59872 19.6329 6.63635 18.9881 5.82699 18.175C5.57562 17.9236 5.33949 17.657 5.12113 17.3777L6.15222 16.5039C6.18246 16.4805 6.20549 16.4491 6.21865 16.4132C6.23181 16.3773 6.23457 16.3384 6.22661 16.301C6.21866 16.2636 6.2003 16.2292 6.17367 16.2017C6.14703 16.1743 6.1132 16.155 6.07605 16.1459L3.03948 15.1458C2.91253 15.1153 2.78811 15.2118 2.78811 15.3413L2.14443 19.138C2.14443 19.3082 2.33994 19.4046 2.47197 19.298L3.60277 18.566C5.55531 21.0619 8.59203 22.6641 12.0045 22.6641C17.8241 22.6641 22.5543 17.9998 22.6635 12.2082C22.6642 12.1811 22.6594 12.1541 22.6495 12.1289C22.6396 12.1037 22.6248 12.0807 22.6058 12.0613C22.5869 12.0419 22.5643 12.0265 22.5393 12.0159C22.5143 12.0054 22.4875 12 22.4604 12Z"
            fill="#595959"
          />
          <path
            d="M9.39832 15.2773C10.4338 15.2773 11.2733 14.4379 11.2733 13.4023C11.2733 12.3668 10.4338 11.5273 9.39832 11.5273C8.36278 11.5273 7.52332 12.3668 7.52332 13.4023C7.52332 14.4379 8.36278 15.2773 9.39832 15.2773Z"
            fill="#595959"
          />
          <path
            d="M11.8004 9.89844C12.6288 9.89844 13.3004 9.22686 13.3004 8.39844C13.3004 7.57001 12.6288 6.89844 11.8004 6.89844C10.972 6.89844 10.3004 7.57001 10.3004 8.39844C10.3004 9.22686 10.972 9.89844 11.8004 9.89844Z"
            fill="#595959"
          />
          <path
            d="M14.7935 16.7305C15.9325 16.7305 16.856 15.8071 16.856 14.668C16.856 13.5289 15.9325 12.6055 14.7935 12.6055C13.6544 12.6055 12.731 13.5289 12.731 14.668C12.731 15.8071 13.6544 16.7305 14.7935 16.7305Z"
            fill="#595959"
          />
        </svg>
      )}
    />
  );
}

export default ConsumableIcon;
